// extracted by mini-css-extract-plugin
export default {"default":"ChangeLanguageModal__default__R74kv"};